import { ref } from 'vue';
import { defineStore, getActivePinia } from 'pinia';
import { createApi } from "@/lib/api.service.js";
import { getUser, updateUser } from '@/lib/api/users';

export const useAuthenticationStore = defineStore('authentication', () => {
  const currentUserKey = ref('current_user');
  const currentUser = ref(null);
  const passwordResetEmail = ref(null);

  const pinia = getActivePinia();

  const $reset = () => {
    currentUser.value = null
  }

  const authenticateUser = async (username, password) => {
    localStorage.removeItem(currentUserKey.value);
    localStorage.removeItem('current_vehicle');
    localStorage.removeItem('user_location');
    pinia._s.forEach(store => {
      store.$reset();
    });

    const user = {
      user: {
        email: username,
        password: password
      },
    };

    try {
      let url = `${import.meta.env.VITE_BACKEND_URL}/api/v2/users/sign_in`;
      const response = await createApi(url, user);

      if (response.status >= 200 && response.status < 300) {
        currentUser.value = response.json;
        localStorage.setItem(currentUserKey.value, JSON.stringify(currentUser.value));
        
        // Show success toast
        try {
          const { useToastStore } = await import('@/stores/toast.js');
          const { useI18n } = await import('vue-i18n');
          const toastStore = useToastStore();
          const { t } = useI18n();
          toastStore.success(t('toast.login_success'));
        } catch (e) {
          console.log('Toast notification failed:', e);
        }
        
        return currentUser.value;
      } else {
        throw new Error(response.json.error);
      }
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const unauthenticateUser = async () => {
    // try {
      // TODO: Need to come back to this, doesn't currently work 100%
      // let url = `${import.meta.env.VITE_BACKEND_URL}/api/v2/users/sign_out`;
      // const response = await deleteApi(url);
      //
      // if (response.status >= 200 && response.status < 300) {
        localStorage.removeItem(currentUserKey.value);
        localStorage.removeItem('current_vehicle'); // I would've grabbed the key straight from the garage store, but there's no clear way to import garage store from here.
        localStorage.removeItem('user_location');

        pinia._s.forEach(store => {
          store.$reset();
        });
        
        // Show success toast
        try {
          const { useToastStore } = await import('@/stores/toast.js');
          const { useI18n } = await import('vue-i18n');
          const toastStore = useToastStore();
          const { t } = useI18n();
          toastStore.success(t('toast.logout_success'));
        } catch (e) {
          console.log('Toast notification failed:', e);
        }

    //     return currentUser.value;
    //   } else {
    //     throw new Error(response.json.error);
    //   }
    // } catch (e) {
    //   console.error(e);
    //   throw e;
    // }
  };

  const deleteUserAccount = () => {
    updateUser(currentUser.value.authenticatable_id, {archived: true, deleted: true})
    unauthenticateUser();

    // Navigate to the home page.
    // I can't use the router here or it creates a dependency loop
    window.location.href = "/"
  };

  // Append the user object to the currentUser auth info
  const setUserCurrentUser = (user) => {
    currentUser.value.user = user;
    localStorage.setItem(currentUserKey.value, JSON.stringify(currentUser.value));
  }

  const loadUserData = async () => {
    const savedUser = localStorage.getItem(currentUserKey.value);
    if (savedUser) {
      currentUser.value = JSON.parse(savedUser);

      try {
        const user = await getUser(currentUser.value.authenticatable_id);
        setUserCurrentUser(user.data);
      } catch (e) {
        // Don't call unauthenticateUser here as it may cause loops
        // The 401 handler in intelichek-fetch will handle logout
        currentUser.value = null
        localStorage.removeItem(currentUserKey.value)
      }
    }
  };

  const updateUserData = async () => {
    try {
      const user = await getUser(currentUser.value.authenticatable_id);
      setUserCurrentUser(user.data);
    } catch (e) {
      console.error("Failed to fetch updated user data", e);
    }
  }

  const sendPasswordResetEmail = async () => {
    const user = {
      email: passwordResetEmail.value
    };

    fetch(`${import.meta.env.VITE_BACKEND_URL}/api/v2/servicechek/users/send_password_reset_email`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(user)
    })
    .then(response => {
    })
    .catch(error => {
        console.error('Error:', error);
    });
  }

  return {
    currentUser,
    authenticateUser,
    unauthenticateUser,
    setUserCurrentUser,
    updateUserData,
    loadUserData,
    deleteUserAccount,
    sendPasswordResetEmail,
    passwordResetEmail,
    $reset
  };
});